<template>
  <div class="d-flex flex-column flex-grow-1">
    <TabHeader :header="$t('js.sidebar.headers.candidacies')" />
    <div class="flex-grow-1 p-3 bg-blur-dark pretty-scroll-theme" id="chat" @scroll="checkScroll"
      style="overflow-y: auto; height: 0;">
      <div v-if="candidacies.length < 1" class="text-white-50 font-italic text-center">
        {{ $t('js.sidebar.candidacies.no_candidacies') }}
      </div>
      <Candidacy v-for="item in candidacies" :item="item" :key="`candidacy_${item.id}`" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import TabHeader from "./TabHeader.vue";
import Candidacy from "@/components/shared/posts/Candidacy.vue";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import { useVotingModulesStore } from "@/entrypoints/stores/voting_modules";
import type { UserPost, Slide } from "@/types";

export default defineComponent({
  name: "Candidacies",
  components: { Candidacy, TabHeader },
  data() {
    return {
      scrolled: false,
    }
  },
  computed: {
    ...mapState(useVotingModulesStore, ["posts"]),
    ...mapState(usePresentationStore, ["slides", "activeSlide"]),
    candidacies() {
      return this.posts.filter((p: UserPost) => p.type === "Candidacy");
    },
    ballotSlides() {
      return this.slides.filter((s: Slide) => s.type === "Slides::BallotSlide");
    },
  },
  watch: {
    posts: {
      handler() {
        if (!this.scrolled) {
          this.$nextTick(function () {
            const d = $("#chat");
            d.scrollTop(d.prop("scrollHeight"));
          });
        }
      }, deep: true,
    },
  },
  methods: {
    validateForm() {
      this.errors = [];
      if (!this.target_slide_id) this.errors.push("slide_required");
      if (this.message.length < 1) this.errors.push("motivation_required");
      return this.errors.length === 0;
    },
    checkScroll() {
      const d = $("#chat");
      this.scrolled = (d.scrollTop()) < (d.prop("scrollHeight") - d.prop("offsetHeight"));
    }
  },
  mounted() {
    if (this.activeSlide && this.activeSlide.type === "Slides::BallotSlide") {
      this.target_slide_id = this.activeSlide.id;
    }

    this.$nextTick(function () {
      const d = $("#chat");
      d.scrollTop(d.prop("scrollHeight"));
    });
  },
});
</script>
